import React from 'react'
import shortid from 'shortid'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { upsertForm } from '../../reducers/form'
import { formStates } from '../../constants/helper-states'

class SHSForm extends React.Component {
    state = {
        formId: shortid.generate()
    }

    componentDidMount = () => {
        this.props.dispatch(upsertForm({ id: this.state.formId, status: formStates.EMPTY }))
    }

    componentDidUpdate = (prevProps) => {
        const formStatus = this.props.forms.find(form => (form.id === this.state.formId))
        const prevFormStatus = prevProps.forms.find(form => (form.id === this.state.formId))
        // TODO: add check for previous form status...actually, do we need that?
        if (formStatus && formStatus.status === formStates.SUCCESS && prevFormStatus.status !== formStates.SUCCESS) {
            // TODO: look at props to figure out what we should do here, but default is to send body back
            if (this.props.resetForm === true) {
                this.props.dispatch(upsertForm({ id: this.state.formId, status: formStates.EMPTY }))
            }
            this.props.successFX(formStatus.body)
        }
    }

    handleChange = (evt) => {
        const value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value
        this.setState({ [evt.target.id]: value })
    }

    handleSubmit = (evt) => {
        evt.preventDefault()
        let validated = evt.target.checkValidity()
        evt.target.classList.remove('was-validated')
        if (!validated) {
            evt.target.classList.add('was-validated')
        } else {
            const { formId } = this.state
            const formDataObj = new FormData(evt.target)
            this.props.dispatch(upsertForm({ id: formId, status: formStates.PROCESSING }))
            if (this.props.useFormData) {
                // this is used when we need to send raw file data
                this.props.submitFX(formDataObj, formId)
            } else {
                let formData = {}
                formDataObj.forEach((val, key) => {
                    let raw = document.getElementById(key).getAttribute('rawvalue')
                    if (raw !== '' && raw !== null) {
                        formData[key] = raw
                    } else {
                        formData[key] = val
                    }
                })
                this.props.submitFX(formData, formId)
            }
        }
    }

    handleCancel = (evt) => {
        evt.preventDefault()
        this.props.cancelAction()
    }

    renderInline = (formStatus) => {
        return (
            <div className="action-icons">
                <button
                    className="clickable"
                    type="submit"
                    disabled={formStatus && (formStatus.status === 'PROCESSING' || formStatus.status === 'SUCCESS' || this.props.buttonDisabled) ? 'disabled' : null}>
                    <FontAwesomeIcon icon="check" />
                </button>
                {this.props.showCancel &&
                    <button
                        className="clickable cancel"
                        onClick={this.handleCancel}>
                        <FontAwesomeIcon icon="times" />
                    </button>
                }
            </div>
        )
    }

    renderStandard = (formStatus) => {
        const buttonLabel = this.props.buttonLabel || 'Submit'
        return (
            <div className={`${this.props.formClass || 'flex-100 w-100 '}`}>
                <button
                    type="submit"
                    className={`btn submit ${this.props.buttonClass || ''}`}
                    disabled={formStatus && (formStatus.status === 'PROCESSING' || formStatus.status === 'SUCCESS' || this.props.buttonDisabled) ? 'disabled' : null} >
                    {formStatus && formStatus.status === 'SUCCESS' ? 'Redirecting...' : buttonLabel}
                </button>
                {this.props.showCancel &&
                    <button className={`btn cancel ${this.props.buttonClass || ''}`} onClick={this.handleCancel}>
                        {this.props.cancelButtonLabel || 'Cancel'}
                    </button>
                }
            </div>
        )
    }

    render = () => {
        const formStatus = this.props.forms.find(stateForm => stateForm.id === this.state.formId)
        const formActions = this.props.inline ? this.renderInline(formStatus) : this.renderStandard(formStatus)
        return (
            <form onSubmit={this.handleSubmit} className={`form ${this.props.extraClass ? this.props.extraClass : ''}`} noValidate>
                {this.props.children}
                {formStatus && formStatus.status === 'ERROR' && formStatus.body !== '' &&
                    <div className="alert alert-danger w-100">
                        {formStatus.body}
                    </div>
                }
                {formActions}
            </form>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        forms: state.forms
    }
}

export default connect(mapStateToProps)(SHSForm)
